import { setNonce } from "@stencil/core";

declare global {
  interface Window {
    __cspNonce?: string;
  }
}

export default async () => {
  /**
   * The code to be executed should be placed within a default function that is
   * exported by the global script. Ensure all of the code in the global script
   * is wrapped in the function() that is exported.
   */

  if (typeof window !== "undefined") {
    setNonce(window.__cspNonce);
  }
};
